// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__gKZ7f","insightsList":"newBusinessInsightsMenu_insightsList__1_Y6e","active":"newBusinessInsightsMenu_active__1LzFj"};